declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild, SimpleChanges, OnChanges } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DOCService } from '../../../../services/doc.service';
import { DownloadFileRequest } from '../../../../models/docs/doc.model';
import { ActorIdentitiesRequest, ActorDocRequest, ActorDocController, SaveCounsellingPlanRequest, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, CounsellingPlanRequest, CounsellingPlanController, CodeTypeRequest, SaveConsumptionGroupRequest, SaveConsumptionGroupItemRequest, MaterialSpecsController, ConsumptionGroupItemsController, CustomCodeValuesController } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { DBOperation } from '../../../../enums/enum';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';

@Component({
  selector: 'ngbaddgroupitem',
  templateUrl: './addgroupitem.modal.html',

  styleUrls: ['./addgroupitem.modal.scss']
})

export class NgbAddGroupItemModal implements OnChanges, OnInit {

  @Input() ConsumptionGroup;
  @Input() isEdit: boolean = false;
  @Input() editGroupItem: ConsumptionGroupItemsController;
  @Input() matSpec: MaterialSpecsController;
  @Input() ActorDocCode;
  @Input() DownloadActorImageFileExtension: string;
  @Input() DownloadActorImageFile: string;
  @Input() FormattedCode: string;
  @Input() CanEdit: number;
  @Input() CanShow: number;

  DOB: NgbDateStruct;
  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;

  StartDate: NgbDateStruct;
  EndDate: NgbDateStruct;
  RecommendedPackage: string;
  Doctor: string;
  PackageCost: number;
  SelectEmi: boolean;
  public FacilityName: string;
  Concerns: string;
  AddRemarks: string;
  file: File;
  fileList: FileList;



  FileExtension: string = "";
  MaritalStatus: string;
  JobType: string;
  public isRequesting: boolean = false;
  public ShowList: boolean = true;
  //public isEdit: boolean = false;
  public ApiResData: ApiResponseModel;
  public ApiReqData: ApiRequestModel
  private modalRef: NgbModalRef;
  private isvisible = true;
  DocFriendlyName: string = "";

  CurrentSaveConsumptionGroupItemRequest: SaveConsumptionGroupItemRequest
    = new SaveConsumptionGroupItemRequest();

  @ViewChild('f') IdentitiesForm: NgForm;

  ActorCode: number;
  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService, private docservice: DOCService,
    private router: Router, private route: ActivatedRoute, private actorservice: ActorService, private tosterservice: NGXToastrService, private parserFormatter: NgbDateParserFormatter) { }
  ngOnInit() {
    this.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    //this.CurrentSaveConsumptionGroupItemRequest = new SaveConsumptionGroupItemRequest();
    this.CurrentSaveConsumptionGroupItemRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    if (this.matSpec != null) {
      var ms = this.matSpec;
      this.CurrentSaveConsumptionGroupItemRequest.ItemName = ms.MaterialName;
      this.CurrentSaveConsumptionGroupItemRequest.MinQty = 1;
      this.CurrentSaveConsumptionGroupItemRequest.MaxQty = 20;
      this.CurrentSaveConsumptionGroupItemRequest.ItemCode = ms.MaterialSpecCode;
      this.CurrentSaveConsumptionGroupItemRequest.UomName = ms.Uom;
      this.CurrentSaveConsumptionGroupItemRequest.GroupCode = this.ConsumptionGroup;
      this.CurrentSaveConsumptionGroupItemRequest.GroupItemCode = 0;
    }
    else if (this.editGroupItem != null) {
      var cgi = this.editGroupItem;
      this.CurrentSaveConsumptionGroupItemRequest.ItemName = this.editGroupItem.ItemName;
      this.CurrentSaveConsumptionGroupItemRequest.MinQty = this.editGroupItem.MinQty;
      this.CurrentSaveConsumptionGroupItemRequest.MaxQty = this.editGroupItem.MaxQty;
      this.CurrentSaveConsumptionGroupItemRequest.ItemCode = this.editGroupItem.ItemCode;
      this.CurrentSaveConsumptionGroupItemRequest.UomName = this.editGroupItem.Uom;
      this.CurrentSaveConsumptionGroupItemRequest.GroupCode = this.editGroupItem.GroupCode;
      //  this.CurrentSaveConsumptionGroupItemRequest.GroupItemCode = this.editGroupItem.GroupItemCode;
    }
    //alert(ms.Uom);
  }
  ngOnChanges(changes: SimpleChanges) {
    //  alertFunctions.AlertParam("in ng on changes");
  }
  //ngOnChanges(changes: SimpleChanges) {
  //  alertFunctions.AlertParam("in ng on changes");
  //  alert('in ng on changes');
  //  if (this.CurrentSaveConsumptionGroupItemRequest == null) {
  //      }
  //  let msChange = changes["matSpec"];
  //  //if (!msChange.firstChange) {
  //    if (msChange.currentValue.currentValue != null) {
  //      var ms = msChange.currentValue as MaterialSpecsController;
  //      this.CurrentSaveConsumptionGroupItemRequest.ItemName = ms.MaterialName;
  //      this.CurrentSaveConsumptionGroupItemRequest.MinQty = 1;
  //      this.CurrentSaveConsumptionGroupItemRequest.MaxQty = 20;
  //      this.CurrentSaveConsumptionGroupItemRequest.ItemCode = ms.MaterialSpecCode;
  //    }
  // // }
  //  //for (const propName in changes) {
  //  //  if (changes.matSpec == changes[propName]) {
  //  //    alert('mat spec changed')
  //  //    if (changes.matSpec.currentValue != null) {
  //  //      var ms = changes.matSpec.currentValue as MaterialSpecsController;
  //  //      this.CurrentSaveConsumptionGroupItemRequest.ItemName = ms.MaterialName;
  //  //      this.CurrentSaveConsumptionGroupItemRequest.MinQty = 1;
  //  //      this.CurrentSaveConsumptionGroupItemRequest.MaxQty = 20;
  //  //      this.CurrentSaveConsumptionGroupItemRequest.ItemCode = ms.MaterialSpecCode;
  //  //    }
  //  //    //if (changes.matSpec.isFirstChange && !this.isEdit) {
  //  //    //  if (changes.matSpec.currentValue != null) {
  //  //    //    var ms = changes.matSpec.currentValue as MaterialSpecsController;
  //  //    //    this.CurrentSaveConsumptionGroupItemRequest.ItemName = ms.MaterialName;
  //  //    //    this.CurrentSaveConsumptionGroupItemRequest.MinQty = 1;
  //  //    //    this.CurrentSaveConsumptionGroupItemRequest.MaxQty = 20;
  //  //    //    this.CurrentSaveConsumptionGroupItemRequest.ItemCode = ms.MaterialSpecCode;
  //  //    //  }
  //  //    //}
  //  //    //else if (!this.isEdit) {
  //  //    //  if (changes.matSpec.currentValue != null) {
  //  //    //    var ms = changes.matSpec.currentValue as MaterialSpecsController;
  //  //    //    this.CurrentSaveConsumptionGroupItemRequest.ItemName = ms.MaterialName;
  //  //    //    this.CurrentSaveConsumptionGroupItemRequest.MinQty = 1;
  //  //    //    this.CurrentSaveConsumptionGroupItemRequest.MaxQty = 20;
  //  //    //    this.CurrentSaveConsumptionGroupItemRequest.ItemCode = ms.MaterialSpecCode;
  //  //    //  }
  //  //    //}
  //  //  } else
  //  //    if (changes.editGroupItem == changes[propName]) {
  //  //      alert('editGroupItem changed')
  //  //      if (changes.editGroupItem.currentValue != null) {
  //  //        var cgi = changes.editGroupItem.currentValue as ConsumptionGroupItemsController;
  //  //        this.CurrentSaveConsumptionGroupItemRequest.ItemName = cgi.ItemName;
  //  //        this.CurrentSaveConsumptionGroupItemRequest.MinQty = cgi.MinQty;
  //  //        this.CurrentSaveConsumptionGroupItemRequest.MaxQty = cgi.MaxQty;
  //  //        this.CurrentSaveConsumptionGroupItemRequest.ItemCode = cgi.ItemCode;
  //  //      }
  //  //      //if (changes.editGroupItem.isFirstChange && this.isEdit) {
  //  //      //  if (changes.editGroupItem.currentValue != null) {
  //  //      //    var cgi = changes.editGroupItem.currentValue as ConsumptionGroupItemsController;
  //  //      //    this.CurrentSaveConsumptionGroupItemRequest.ItemName = cgi.ItemName;
  //  //      //    this.CurrentSaveConsumptionGroupItemRequest.MinQty = cgi.MinQty;
  //  //      //    this.CurrentSaveConsumptionGroupItemRequest.MaxQty = cgi.MaxQty;
  //  //      //    this.CurrentSaveConsumptionGroupItemRequest.ItemCode = cgi.ItemCode;
  //  //      //  }
  //  //      //}
  //  //      //else if (this.isEdit) {
  //  //      //  if (changes.editGroupItem.currentValue != null) {
  //  //      //    var cgi = changes.editGroupItem.currentValue as ConsumptionGroupItemsController;
  //  //      //    this.CurrentSaveConsumptionGroupItemRequest.ItemName = cgi.ItemName;
  //  //      //    this.CurrentSaveConsumptionGroupItemRequest.MinQty = cgi.MinQty;
  //  //      //    this.CurrentSaveConsumptionGroupItemRequest.MaxQty = cgi.MaxQty;
  //  //      //    this.CurrentSaveConsumptionGroupItemRequest.ItemCode = cgi.ItemCode

  //  //      //  }
  //  //      //}
  //  //    }
  //  //}




  //}


  onSubmit() {

    this.CurrentSaveConsumptionGroupItemRequest.ConditionalOperator = 10;
    this.CurrentSaveConsumptionGroupItemRequest.ItemCode = this.matSpec.MaterialSpecCode;

    this.actorservice.SaveConsumptionGroupItem(this.CurrentSaveConsumptionGroupItemRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            //this.isvisible = false;
            this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.activeModal.close();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();
          }
        }
      );

  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }


}





  //GetActorDocController() {
  //  this.StartRefreshing();
  //  this.docservice.GetActorDocController(this.CurrentActorDocRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {

  //        this.CurrentActorDocController = this.ApiResData.Result;
  //        this.initGridButton();
  //        this.stopRefreshing();

  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //        }
  //      }

  //    },


  //    (error) => {

  //      if (error == "401 - Unauthorized") {
  //        alertFunctions.AlertParamEr(error);
  //        this.stopRefreshing();



  //      }
  //      else {
  //        alertFunctions.AlertParamEr(error);
  //        this.stopRefreshing();
  //      }
  //    }


  //    );

  //}



  /////////////////////////



  //

  // https://www.codeproject.com/Articles/1195569/Angular-Data-Grid-with-Sorting-Filtering-Export-to
  // dbops: DBOperation;
  //Grid Vars start














  /////////////////////////

